import React from 'react'
import { styled } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons/faCircleInfo'
import { AlertContainerComponent } from '@app/components/ui/containers/AlertContainer'
import { FeedbackContent } from './FeedbackContent'

type GeneralFeedbackProps = {
  generalFeedback?: React.ReactNode
}

const StyledAlertContainer = styled(AlertContainerComponent)(({ theme }) => ({
  marginTop: theme.spacing(4),
  padding: theme.spacing(3, 2, 3, 4),
}))

const StyledInfoIcon = styled(FontAwesomeIcon)(({ theme }) => ({
  fontSize: theme.typography.body2.fontSize,
}))

export const GeneralFeedback: React.FC<GeneralFeedbackProps> = ({ generalFeedback }) => {
  if (!generalFeedback) {
    return null
  }

  return (
      <StyledAlertContainer
        severity="info"
        variant="outlined"
        icon={<StyledInfoIcon icon={faCircleInfo} />}
        data-automation-id="general-feedback-container"
      >
        <FeedbackContent variant="body2" color="inherit" component="div">
          {generalFeedback}
        </FeedbackContent>
      </StyledAlertContainer>
  )
}
